module.exports = ".rowSpace {\n  margin-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vir/vir.component.scss
// module id = ./client/app/vir/vir.component.scss
// module chunks = main